<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.full_name"
  >
    <form
      :action="urlPulsa2"
      method="post"
      target="_blank"
      v-show="this.actor.privilege == 'General User'"
    >
      <input type="hidden" v-model="tokenPortal" name="token" />
      <button
        type="submit"
        style="
          background-color: transparent;
          background-repeat: no-repeat;
          border: none;
          cursor: pointer;
          overflow: hidden;
          outline: none;
        "
      >
        <img
          src="@/assets/images/pulsa/pulsa_icon.svg"
          alt=""
          style="margin-right: 20px; cursor: pointer; filter: invert(0.45)"
        />
      </button>
      <!-- <a type="submit">
        <img
          src="@/assets/images/pulsa/pulsa_icon.gif"
          alt=""
          style="margin-right: 20px; cursor: pointer"
        />
      </a> -->
    </form>

    <div class="text-right leading-tight block">
      <p class="font-semibold" style="font-size: 11px; margin: 0">
        {{ activeUserInfo.full_name }}
      </p>
      <small>{{ activeUserInfo.privilege }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          ref="user-dropdown"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="profile"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <!-- <vs-divider class="m-1" v-if="akses_sspoint == true" />

          <li
            v-if="akses_sspoint == true"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="goToSspoin"
          >
            <feather-icon icon="DollarSignIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">SS POIN</span>
          </li> -->

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/email').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/todo').catch(() => {})">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/chat').catch(() => {})">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li> -->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import API from '@/API.js'
const axios = require('axios')

export default {
  data() {
    return {
      actor: '',
      token: '',
      tokenPortal: '',
      urlPulsa2: '',
      urlSSPoint: '',
      list_akses: [
        'sscpontianak',
        'trakindo',
        'sby_rob',
        'nitrous_pix',
        'albymuh',
        'h8867eh',
        'hjg',
        'rudy5758',
        'indohose',
        'sam5758',
        'ss_ptkdemo',
        'ss_ptkdemo1',
        'rt5'
      ],
      akses_sspoint: false
    }
  },
  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.tokenPortal = localStorage.getItem('tokenPortal')
    this.urlPulsa2 = this.$api.pulsa
    this.urlSSPoint = this.$api.sspoin
    this.actor =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo'))
        : ''

    this.list_akses.map((item) => {
      if (item === this.actor.username) {
        this.akses_sspoint = true
      }
    })
  },

  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('isGenerate')
      localStorage.removeItem('client_ip')
      localStorage.removeItem('fcmToken')
      localStorage.removeItem('tokenPortal')
      localStorage.removeItem('infoSscAdmin')
      localStorage.removeItem('journeyData')
      localStorage.removeItem('journeyDataDetail')
      localStorage.removeItem('isVerifiedEmail')
      localStorage.removeItem('isVerifiedPhone')
      localStorage.removeItem('infoSscAdmin')
      localStorage.removeItem('emailVerifAttention')

      // this.$router.push({ path: '/login'})
      window.location.href = API.portal_url + '/logout/' + this.token
    },

    profile() {
      this.$refs['user-dropdown'].click()
      this.$router.push('/profile').catch(() => {})
    },

    goToSspoin() {
      const token = JSON.parse(localStorage.getItem('userInfo')).token
      // window.location.href = `http://pulsaku.vv/login/${token}`
      window.open(`${this.urlSSPoint + '/' + token}`, '_blank')
    }
  }
}
</script>
